import { useState, useEffect, useCallback } from "react";
import { Api } from "../request/api/api";
import { EquipmentCategory, CreateEquipmentCategoryDto, UpdateEquipmentCategoryDto } from "../model/Dto/Dict/EquipmentCategory";

export function useEquipmentCategories() {
    const [categories, setCategories] = useState<EquipmentCategory[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchCategories = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllEquipmentCategories();
            setCategories(result);
        } catch (err) {
            setError("Ошибка загрузки категорий экипировки");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const createCategory = useCallback(async (data: CreateEquipmentCategoryDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createEquipmentCategory(data);
            if (result) {
                await fetchCategories();
                return true;
            }
            setError("Ошибка создания категории");
            return false;
        } catch (err) {
            setError("Ошибка создания категории");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchCategories]);

    const updateCategory = useCallback(async (id: string, data: UpdateEquipmentCategoryDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateEquipmentCategory(id, data);
            if (result) {
                await fetchCategories();
                return true;
            }
            setError("Ошибка обновления категории");
            return false;
        } catch (err) {
            setError("Ошибка обновления категории");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchCategories]);

    const deleteCategory = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteEquipmentCategory(id);
            if (result) {
                await fetchCategories();
                return true;
            }
            setError("Ошибка удаления категории");
            return false;
        } catch (err) {
            setError("Ошибка удаления категории");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchCategories]);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    return { categories, loading, error, createCategory, updateCategory, deleteCategory, refetch: fetchCategories };
}